<template>
    <div class="container-fluid  pt-2">
        <div v-if="supplierId">
<div class="container">
    <div class="pt-5">
<div class="row">
    <div class="col-6">
             <h1 class="font-weight-bold text-capitalize ">Supplier: {{ selectedSupplier.supplier }}</h1>
        <hr />
        <p>Contacts : {{ selectedSupplier.phone }} |  {{ selectedSupplier.email }}</p>

    </div>
    <div class="col-6">
        <div class="dropdown float-right">

            <a type="button" class="btn btn-sm px-2 btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Action</a>
            <div class="dropdown-menu">

                <a class="dropdown-item"  v-b-modal.modal-supplier-payment>Record Payment</a>
                <a class="dropdown-item" v-b-modal.modal-download-statement >Update Details</a>
                <a class="dropdown-item" :href="`/supplier-statement?id=${selectedSupplier.id}`" >View Statement</a>
                <a class="dropdown-item" v-b-modal.modal-download-statement >Download Statement</a>
                <a class="dropdown-item text-danger" v-b-modal.modal-suspend-supplier >Suspend</a>




            </div>
        </div>
    </div>

</div>


        <hr />

 <div>


    <div>
        <div class="card">
            <div class="card-body">
                <div class="row text-center">
                    <div class="col-4 border-right">
                        <h4>{{ convertCurrencyToLocal(report.totals?.total_spent) }}</h4>
                        <p>Total Spent </p>
                    </div>
                    <div class="col-4 border-right">
                        <h4>{{ convertCurrencyToLocal(report.totals?.balance)}}</h4>
                        <p>Balance </p>
                    </div>
                    <div class="col-4 border-right">
                        <h4>{{ report.totals?.average_days_between_restocks ?? '—' }}</h4>
                        <p>Average days between restocks </p>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div>
      <h4>Top Items</h4>

      <table class="table table-striped">
        <thead>
            <td>Item</td>
            <td>Count</td>
            <td>Quantity</td>
        </thead>
        <tbody>
            <tr v-for="(val, pid) in report.top_products" :key="pid">
                <td>{{ val.product.product }}</td>
                <td>{{ val.count }}</td>
                <td>{{ val.qty }}</td>
            </tr>
        </tbody>
      </table>
    </div>

    <div>
      <h4>Purchases</h4>
     <table class="table table-striped">
        <thead>
            <td>Purchase Order</td>
            <td>Amount</td>
            <td>Date</td>
        </thead>
        <tr v-for="p in report.purchases" :key="p.id">
          <td>{{ p.purchase_order }}</td><td>{{ convertCurrencyToLocal(p.total_amount) }}</td>
          <td>{{ FormatDate(p.created_at) }}</td>
        </tr>
      </table>
    </div>
  </div>


    </div>

</div>

        <div v-if="selectedSupplier && selectedSupplier.supplier_reps && selectedSupplier.supplier_reps.length">
            <p>Representative</p>
  <p v-if="selectedSupplier.supplier_reps[0].name">Name: {{ selectedSupplier.supplier_reps[0].name }}</p>
  <p v-if="selectedSupplier.supplier_reps[0].phone">Phone: {{ selectedSupplier.supplier_reps[0].phone }}</p>
  <p v-if="selectedSupplier.supplier_reps[0].email">Email: {{ selectedSupplier.supplier_reps[0].email }}</p>
</div>
<div class="container py-3">



</div>


        </div>
        <div v-else class="pt-5">
            <div class="row">
                <div class="col-md-4 col-sm-4">
                    <div class="text-left py-1">
                        <h4 class="text-weight-900">Suppliers </h4>
                    </div>
                </div>
                <div class="col-md-8 col-sm-12">
                    <div class="text-right py-1">
                        <a v-b-modal="'new-supplier-modal'" class="btn btn-primary">Create Supplier <i
                                class="bi bi-plus"></i></a>
                        <a @click="downloadSuppliersFile" class="btn btn-outline-secondary">Download List <i
                                class="bi bi-download"></i></a>
                    </div>
                </div>
            </div>
            <div class="pt-5">
                <form @submit.prevent="submitSearchCustomer" class="form-inline">
                    <div class="input-group w-100 my-1">
                        <input type="text" class="form-control"
                            placeholder="Search Supplier">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div style="margin-bottom: 5em;">
                <b-table striped hover sticky-header="100vh" :items="suppliersTable.items"
                    :fields="suppliersTable.fields" sort-icon-left responsive="sm" @row-clicked="supplierRowSelected">
                    <template #cell(index)="data">
                        <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                        <span>{{ data.index + 1 }}</span>
                    </template>

                    <template #cell(name)="data">
                        <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                        <p class="text-primary underline-primary">{{ data.item.name }}</p>
                    </template>



                </b-table>
            </div>




            <b-modal ref="newSupplierModal" id="new-supplier-modal" hide-footer static>

                <div class="container text-center">
                    <div class="text-centre">
                        <h2 class="font-weight-bold ">Add New Supplier</h2>
                    </div>

                </div>

                <div class="container py-3">
                    <!-- Actual search box -->
                    <form @submit.prevent="createNewSupplier">
                        <p>Company details</p>
                        <div class="form-group">
                            <input class="form-control border-bottom" v-model="supplierDetails.supplier.supplier"
                                type="text" placeholder="Company Name" required />

                        </div>

                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="supplierDetails.supplier.email"
                                    type="email" placeholder="Email" />
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="supplierDetails.supplier.phone"
                                    type="text" placeholder="Phone Number" />

                            </div>


                        </div>
                        <hr />
                        <p>Company representative details</p>
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom"
                                    v-model="supplierDetails.supplier.supplier_representatives.name" type="text"
                                    placeholder="Representative " />
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom"
                                    v-model="supplierDetails.supplier.supplier_representatives.phone" type="text"
                                    placeholder="Phone" />

                            </div>


                        </div>

                        <div class="form-group pt-3">
                            <button class="btn btn-primary btn-block">Add Supplier</button>
                        </div>
                    </form>
                </div>



            </b-modal>

        </div>

        <!-- MODALS -->

         <b-modal  id="modal-supplier-payment" hide-footer hide-header static>

           <supplier-payment-recording>
</supplier-payment-recording>
        </b-modal>
    </div>
</template>

<script>
import SupplierPaymentRecording from '../modal/SupplierPaymentRecording.vue';

    export default {
        name: 'suppliers',

        components: {SupplierPaymentRecording},
        data() {
            return {
                suppliersTable: {
                    fields: [
                        "index",
                        {
                            key: "name",
                            sortable: true
                        },
                        {
                            key: "email",
                            sortable: true
                        },
                        {
                            key: "phone",
                            sortable: true
                        },

                        {
                            key: "date_added",
                            sortable: true
                        }

                    ],
                    items: [],
                },
                orderstable: {
                    fields: [
                        "index",
                        {
                            key: "order",
                            sortable: true
                        },
                        {
                            key: "amount",
                            sortable: true
                        },
                        {
                            key: "date_",
                            sortable: true
                        },
                    ],
                    items: []
                },
                smsForm: {
                    message: ''
                },

                supplierDetails: {
                    supplier: {
                        email: '',
                        phone: '',
                        supplier: '',
                        supplier_representatives: {
                            name: '',
                            email: '',
                            phone: ''
                        },
                    },
                    searchTerm: '',
                    searchTable: false,
                    filteredSuppliers: {},

                },
                selectedSupplier: {},
                supplier: null, report: {}

            }
        },
        computed: {
            supplierId() {
            const params = new URLSearchParams(window.location.search);
            return params.get('id');
            }
        },
        mounted() {

            (this.supplierId) ? this.fetchSuppliers(this.supplierId) : this.getSuppliers()
        },
        methods: {
            customerTrxRowSelected(item) {
                window.location.replace('/orders?order-number=' + item.id + '&source=/suppliers' )
            },
            getSuppliers() {
                axios.get('/api/all-suppliers')
                    .then(result => {

                        this.supplierDetails.supplier = result.data;
                        this.supplierDetails.supplier.supplier_representatives={};

                        let suppliersArray = [];

                        $.each(this.supplierDetails.supplier, function(key, value) {


                            suppliersArray.push({
                                name: value.supplier,
                                email: value.email,
                                phone: value.phone,
                                date_added: moment(value.created_at).format("D-MM-YYYY"),
                                supplier_id: value.id,

                            })
                        });
                        this.suppliersTable.items = suppliersArray;
                    });
            },
            async fetchSuppliers(id)
            {
                await axios.get(`/api/reports/suppliers/${id}`).then(results=>{
                    const res = results.data
                this.selectedSupplier=res.supplier;
                   this.supplier = res.supplier;
                    this.report = res;


               })
            },
            supplierRowSelected(items) {
                window.location.href=`/suppliers?id=${items.supplier_id}`

            },
            sendSMSToCustomer() {
                axios.post('/api/send-sms-to-customer', {
                    customer: this.customer_data,
                    message: this.smsForm.message
                }).then(results => {
                    if (results.delivery === 'success') {
                        this.$toasts.push({
                            'type': "success",
                            "message": "Message sent successfully"
                        })
                    }
                    this.$refs.textmessage_modal.hide()
                })
            },

            submitSearchCustomer() {
                this.getCustomers();
            },
            FormatDate(date) {
                let finaldate = moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
            DeleteCustomer(customer_id) {
                axios.get('/api/customer_delete', {
                        params: {
                            customer_id
                        }
                    })
                    .then(result => {
                        this.$root.$toasts.push({
                            type: 'success',
                            message: "Customer data has been deleted",
                        });
                        this.$refs['customermodaldel'].hide();
                        this.getCustomers();
                    });
            },
            async createNewSupplier() {
                await axios.post('/api/new-supplier', { ...this.supplierDetails.supplier
                }).then(results => {
                    if (results.status === 200) {
                        this.supplierDetails.supplier = results.data.supplier
                        this.supplierDetails.supplier.supplier_representatives = results.data.rep.supplier_representatives
                        this.$refs.newSupplierModal.hide()
                    }
                }).catch(errors => {
                })
            },
            EditCustomerInfo(e) {
                e.preventDefault();
                axios.post('/api/updatecustomer', {
                        customer_id: this.selected_customer,
                        town: this.town,
                        street: this.street,
                        apartment: this.apartment,
                        h_no: this.h_no,
                        phone_no: this.phone_no,
                        email: this.c_email,
                        l_name: this.l_name,
                        f_name: this.f_name
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.$root.$toasts.push({
                                type: 'success',
                                message: "Customer data updated successfully",
                            });
                            this.$refs['edit-customer-modal'].hide();
                            this.getCustomers()
                        } else {
                            this.$root.$toasts.push({
                                type: 'error',
                                message: "There was an error adding customer",
                            });
                        }
                    });
            },
            EditCustomerModal() {
                this.$refs['edit-customer-modal'].show();
                this.$refs['customer_profile'].hide();
            },
            downloadSuppliersFile() {
                axios({
                        method: 'get',
                        url: '/api/all-suppliers',
                        responseType: 'blob',
                        params: {
                            export: true
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'suppliers.xlsx'); // Specify the filename
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        console.error('Error downloading file:', error);
                    });
            }
        }
    }
</script>
